/* eslint-disable no-unused-vars */

export const TAX_HIGH = 21;
export const TAX_LOW = 9;
export const TAX_HIGH_FACTOR = TAX_HIGH / 100;
export const TAX_LOW_FACTOR = TAX_LOW / 100;
export const DAY_IN_MS = 24 * 60 * 60 * 1000;
